// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/bundle." + "46e839714132bbb671d7" + ".min.js";
};